import { render, staticRenderFns } from "./management.vue?vue&type=template&id=24fb5700&scoped=true"
import script from "./management.vue?vue&type=script&lang=js"
export * from "./management.vue?vue&type=script&lang=js"
import style0 from "./management.vue?vue&type=style&index=0&id=24fb5700&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fb5700",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24fb5700')) {
      api.createRecord('24fb5700', component.options)
    } else {
      api.reload('24fb5700', component.options)
    }
    module.hot.accept("./management.vue?vue&type=template&id=24fb5700&scoped=true", function () {
      api.rerender('24fb5700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/develop/dictionary/management.vue"
export default component.exports